import { Link } from "react-router-dom";
import { FaBookReader } from "react-icons/fa";

const LmsEmptyState = ({ title, body, actionLabel, actionTo }) => (
  <section className="lms-empty-state">
    <div className="lms-empty-icon" aria-hidden="true">
      <FaBookReader />
    </div>
    <div>
      <h2>{title}</h2>
      <p>{body}</p>
    </div>
    {actionTo ? (
      <Link to={actionTo} className="lms-primary-action">
        {actionLabel}
      </Link>
    ) : (
      <button type="button" className="lms-primary-action">
        {actionLabel}
      </button>
    )}
  </section>
);

export default LmsEmptyState;
